import type { PostHog } from "posthog-js";

/** Registers properties that must survive authenticated identity changes. */
export function registerPostHogBaseline(client: Pick<PostHog, "register">): void {
  client.register({
    release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ?? "dev",
  });
}

/** Clears person/group identity while preserving deploy-level attribution. */
export function resetPostHogIdentity(
  client: Pick<PostHog, "register" | "reset">,
): void {
  client.reset();
  registerPostHogBaseline(client);
}
